import { Box, Button, Stack, Typography } from "@mui/material";
import { AttachFile } from "@mui/icons-material";

import _ from "lodash";

import SectionPreview from "../../../common/components/SectionPreview";
import { dateToStringShort, dateToStringLongSuffix } from "../../../common/utils/dateTime";
import { apiFileDownloadEndpoint } from "../../../common/components/mui-extended/DropzoneExtended";
import { WillPreviewDto } from "../../../interfaces/Will";

type WillProps = {
  model?: WillPreviewDto;
};

const Will = ({ model }: WillProps) => {
  const renderWillData = () => (
    <>
      <Typography>
        Завещание <strong>{`${model?.registrationNumber} / ${dateToStringShort(model?.issueDate)}`}</strong>,
      </Typography>
      <Typography>
        издадено от нотариус <strong>{model?.notary?.name}</strong>, номер{" "}
        <strong>{_.padStart(model?.notary?.number?.toString(), 3, "0")}</strong>, район на действие{" "}
        <strong>{model?.notary?.settlementName}.</strong>
      </Typography>
    </>
  );

  const renderTestatorData = () => (
    <Stack spacing={2}>
      <Box>
        <Typography>
          Име на завещателя и ЕГН - <strong>{model?.testator}</strong>.
        </Typography>
        {model?.birthDate && (
          <Typography component="span">
            Роден на <strong>{dateToStringShort(model?.birthDate)}</strong>.
          </Typography>
        )}{" "}
        {model?.deathDate && (
          <Typography component="span">
            Починал на <strong>{dateToStringShort(model?.deathDate)}</strong>
          </Typography>
        )}
      </Box>
      <Box>
        {model?.notarialNumber && (
          <Typography component="span">
            Н.Д. № и № на акта за нот. зав. <strong>{model.notarialNumber}</strong>.
          </Typography>
        )}{" "}
        {model?.handwrittenNumber && (
          <Typography component="span">
            Рег. сам. зав. № <strong>{model.handwrittenNumber}</strong>.
          </Typography>
        )}
        <Box>
          {model?.handwrittenStatus && (
            <Typography component="span">
              Завещанието е <strong>{model?.handwrittenStatus}</strong>.
            </Typography>
          )}{" "}
          {model?.status && (
            <Typography component="span">
              Статус <strong>{model?.status}</strong>.
            </Typography>
          )}
        </Box>
      </Box>
    </Stack>
  );

  const render = () => {
    return (
      <Stack spacing={3}>
        <Typography variant="subtitle2">
          Дата на въвеждане в регистъра: {dateToStringLongSuffix(model?.createDate)}
        </Typography>
        <SectionPreview title="Данни за завещание">{renderWillData()}</SectionPreview>
        <SectionPreview title="Данни за завещател">{renderTestatorData()}</SectionPreview>
        {model?.file?.blobId && (
          <SectionPreview title="Сканирано копие">
            <Button
              startIcon={<AttachFile />}
              variant="outlined"
              href={`${apiFileDownloadEndpoint}/${model?.file?.blobId}`}
            >
              {model?.file?.name}
            </Button>
          </SectionPreview>
        )}
      </Stack>
    );
  };

  return model ? render() : null;
};

export default Will;
